<template>
  <ul :class="$style.container">
    <li v-for="item in list" :key="item.value" :class="$style.item" @click="item.handler">
      <BaseIcon :name="item.icon" :custom="item.isCustomIcon" :class="$style.icon" />
      <div>{{ item.value }}</div>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'messenger-menu',
  data () {
    return {
      list: [
        {
          value: this.$t('chat.mainMenu.createGroup'),
          icon: 'comment-medical',
          handler: () => {
            this.$modal.show('new-chat')
          }
        },
        // {
        //   value: this.$t('chat.mainMenu.createBlog'),
        //   icon: 'blogger',
        //   isCustomIcon: true,
        //   handler: () => {
        //     if (this.isPremium) {
        //       this.$modal.show('create-blog')
        //     } else {
        //       this.$modal.show('premium-feature')
        //     }
        //   }
        // },
        {
          value: this.$t('chat.mainMenu.contacts'),
          icon: 'address-book',
          handler: () => {
            this.$modal.show('contacts')
          }
        },
        {
          value: this.$t('chat.mainMenu.settings'),
          icon: 'cog',
          handler: () => {
            this.$modal.show('settings')
          }
        },
        {
          value: 'sayhola.io',
          icon: 'arrow-alt-circle-left',
          handler: () => {
            this.$router.push({ name: 'profile' })
          }
        },
        {
          value: this.$t('chat.mainMenu.logout'),
          icon: 'sign-out-alt',
          handler: () => {
            this.$modal.show('logout')
          }
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      isPremium: 'auth/isPremium'
    })
  }
}
</script>

<style lang="scss" module>
.container {
  width: 100%;
  background-color: $main-bg-light;
  color: $text-darkest;
  // border: 1px solid $border-color;
  // border-top: none;
  // border-bottom: none;
  padding: 6px 0;
}
.item {
  height: 55px;
  display: flex;
  font-size: 16px;
  align-items: center;
  cursor: pointer;

  &:hover {
    color: $text-colored;
    .icon {
      color: $text-colored;
    }
  }
}
.icon {
  margin: 0 16px;
  color: $text-light;
  font-size: 20px;
}
</style>
